import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { RECORD_INVOICE_TYPE } from "@/constants";

export const OriginalInvoiceReferenceSection = ({ originalInvoice }) => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  if (!originalInvoice) {
    return null;
  }

  const invoiceTypeName = RECORD_INVOICE_TYPE[originalInvoice.invoiceType]
    ? RECORD_INVOICE_TYPE[originalInvoice.invoiceType](t)
    : originalInvoice.invoiceType;

  return (
    <div className="w-full pb-6">
      <div className="text-xl font-medium pb-4">
        {t("invoices:original_invoice")}
      </div>

      <div className="bg-white rounded-md border p-4">
        <div className="flex flex-wrap gap-4 items-center">
          <div className="flex-1 min-w-[200px]">
            <div className="text-sm text-gray-500 mb-1">
              {t("invoices:invoice_id")}
            </div>
            <div className="flex items-center gap-2">
              <span className="font-medium text-lg">{originalInvoice.invoiceId}</span>
              <Button
                variant="link"
                className="text-blueText p-0 h-auto"
                onClick={() => navigate(`/admin/invoices/details/${originalInvoice.id}`)}
              >
                {t("common:button_view")}
              </Button>
            </div>
          </div>

          <div className="flex-1 min-w-[150px]">
            <div className="text-sm text-gray-500 mb-1">
              {t("invoices:invoice_type")}
            </div>
            <div className="font-medium">{invoiceTypeName}</div>
          </div>

          <div className="flex-1 min-w-[150px]">
            <div className="text-sm text-gray-500 mb-1">
              {t("invoices:date_of_creation")}
            </div>
            <div className="font-medium">
              {new Date(originalInvoice.createdAt).toLocaleDateString()}
            </div>
          </div>

          <div className="flex-1 min-w-[150px]">
            <div className="text-sm text-gray-500 mb-1">
              {t("invoices:counterparty_info")}
            </div>
            <div className="font-medium">{originalInvoice.counterpartyName}</div>
          </div>

          <div className="flex-1 min-w-[150px]">
            <div className="text-sm text-gray-500 mb-1">
              {t("invoices:price_brutto")}
            </div>
            <div className="font-medium">
              {parseFloat(originalInvoice.invoiceBrutto).toFixed(2)} {originalInvoice.paymentCurrency}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
